export default function PHP_getservbyport() {
  return (
    <div>
      <h1>PHP_getservbyport</h1>
    </div>
  );
}
